import DoAPICall from './DoAPICall'

//Create Complaints
export async function createComplaintType(userToken, ComplaintType){
	const apiPayload = {
		httpMethod:'post',
		userToken,
		uri:'complainttypes',
		payLoad:{
			client_id:ComplaintType.client_id,
			code:ComplaintType.code,
			name:ComplaintType.name,
			order:ComplaintType.order
		},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get All Complaints
export async function getComplaintTypes(userToken){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'complainttypes',
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get All Complaints
export async function getComplaintTypesOfClient(userToken,client_id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'complainttypesofclient?client_id='+client_id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get One Complaints
export async function getComplaintType(userToken, id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'complainttypes/'+id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Update Complaints
export async function updateComplaintType(userToken, ComplaintType){
	const apiPayload = {
		httpMethod:'put',
		userToken,
		uri:'complainttypes/'+ComplaintType.id,
		payLoad:{
				code:ComplaintType.code,
				name:ComplaintType.name,
				order:ComplaintType.order
			},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Delete Complaints
export async function deleteComplaintType(userToken, id){
    const apiPayload = {
        httpMethod:'delete',
        userToken,
        uri:'complainttypes/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}